<template>
  <div class="statement">
      <div class="title">亲爱的客户您好：</div>
      <!-- 创建企业 -->
      <div v-if="isShow == 2">
        <div class="txt">
          为增强企业账户的安全性，在创建企业账号前需要您先进行个人实名认证核实您的个人身份。我们将采取人脸识别，银行卡认证和手机认证的方式来验证您的本人身份，您的个人信息将得到绝对的保护。
        </div>
      </div>
      <!-- 加入企业 -->
      <div v-if="isShow == 3">
        <div class="txt">
          为核实您的个人身份，确保您加入正确的企业，在加入企业前需要您先进行个人实名认证。我们将采取人脸识别，银行卡认证和手机认证的方式来验证您的本人身份，您的个人信息将得到绝对的保护。
        </div>
      </div>
      <div class="alert">
        温馨提示：
        <div class="txt txt1">
          如实名认证过程中存在特殊情况，可联系客服 13818696732进行解决
        </div>
      </div>
      
      <Button
          type="primary"
          size="large"
          class="next-btn"
          style="width: 200px"
          @click="next"
          >下一步</Button
        >
        <div class="decs">
        注：e签宝向您提供人脸识别服务并承担责任
      </div>
  </div>
</template>

<script>
export default {
  props:{
    isShow:{
      type: String,
      default: null
    }
  },
  methods: {
    next() {
      this.$emit("next",this.isShow)
    }
  }
};
</script>

<style lang="less" scope>
.statement {
  text-align: left;
  background: #fff;
  font-size: 16px;
  position: relative;
  .txt {
    line-height: 27px;
    margin-top: 15px;
    text-indent: 2em;
  }
  .title {
    margin: 40px 0 10px 0;
  }
  .txt1 {
    margin-top: 0;
  }
  .alert {
    margin-top: 45px;
  }
  .decs {
    position: absolute;
    bottom: -40px;
    font-size: 12px;
    color: #999;
  }
  .next-btn {
    display: block;
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// statement.vue?7004110a